/**
 *  @class
 *  @function UniversalText
 */

if (!customElements.get('universal-text')) {
  class UniversalText extends HTMLElement {
    constructor() {
      super();

      this.tl = false;
      this.splittext = false;
    }
    connectedCallback() {
      this.autoLinkUrls();
      if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
        this.prepareAnimations();
      }
    }
    autoLinkUrls() {
      const rteElements = this.querySelectorAll('.rte');
      const urlPattern = /(https?:\/\/[^\s<]+)/g;

      rteElements.forEach(rte => {
        const walker = document.createTreeWalker(rte, NodeFilter.SHOW_TEXT, null, false);
        const textNodes = [];

        while (walker.nextNode()) {
          if (urlPattern.test(walker.currentNode.textContent)) {
            textNodes.push(walker.currentNode);
          }
          urlPattern.lastIndex = 0;
        }

        textNodes.forEach(textNode => {
          const text = textNode.textContent;
          const fragment = document.createDocumentFragment();
          let lastIndex = 0;
          let match;

          urlPattern.lastIndex = 0;
          while ((match = urlPattern.exec(text)) !== null) {
            if (match.index > lastIndex) {
              fragment.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
            }
            const link = document.createElement('a');
            link.href = match[0];
            link.textContent = match[0];
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
            fragment.appendChild(link);
            lastIndex = urlPattern.lastIndex;
          }

          if (lastIndex < text.length) {
            fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
          }

          textNode.parentNode.replaceChild(fragment, textNode);
        });
      });
    }
    disconnectedCallback() {
      if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
        if (this.tl) {
          this.tl.kill();
        }
        if (this.splittext) {
          this.splittext.revert();
        }
      }
    }
    prepareAnimations() {
      let section = this;

      section.tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: "top bottom"
        }
      });

      document.fonts.ready.then(function() {
        section.splittext = new SplitText(section.querySelectorAll('h3, .rte p'), {
          type: 'lines, words',
          linesClass: 'line-child'
        });

        if (section.querySelector('h3')) {
          let h3_duration = 0.8 + ((section.querySelectorAll('h3 .line-child div').length - 1) * 0.08);
          section.tl
            .set(section.querySelector('h3'), {
              visibility: 'visible'
            }, 0)
            .from(section.querySelectorAll('h3 .line-child div'), {
              duration: h3_duration,
              yPercent: '100',
              stagger: 0.08
            }, 0);
        }

        if (section.querySelector('.rte p')) {
          let p_duration = 0.8 + ((section.querySelectorAll('.rte p .line-child div').length - 1) * 0.02);
          section.tl
            .set(section.querySelectorAll('.rte p'), {
              visibility: 'visible'
            }, 0.3)
            .from(section.querySelectorAll('.rte p .line-child div'), {
              duration: p_duration,
              yPercent: '100',
              stagger: 0.02
            }, 0.3);
        }
      });
    }
  }
  customElements.define('universal-text', UniversalText);
}
